<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 315 315" width="100%" height="100%"  xml:space="preserve">
<g transform="translate(-5 5)">
	<g opacity ="0.15">
		
			<image style="overflow:visible;" width="349" height="90" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAV0AAABaCAYAAAAb+oW7AAAACXBIWXMAAAsSAAALEgHS3X78AAAA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" transform="matrix(1 0 0 1 0.6147 252.4276)">
		</image>
	</g>
	<g>
		<g>
			<path fill="#3B4E9A" d="M232.79,193.79c-0.2-23.32-19.15-42.17-42.52-42.17c-5.63,0-11,1.1-15.92,3.09
				c-8.35-17.08-25.89-28.85-46.19-28.85c-24.55,0-45.06,17.21-50.16,40.22c-23.08,1.48-41.35,20.67-41.35,44.13
				c0,24.43,19.8,44.23,44.23,44.23h140.75c17.32,0,31.35-14.04,31.35-31.35C252.98,209.71,244.59,198.29,232.79,193.79z"/>
			<path fill="#FFFFFF" d="M201.13,179.5H88.5c-1.9,0-3.46-1.56-3.46-3.46l0,0c0-1.9,1.56-3.46,3.46-3.46h112.63
				c1.9,0,3.46,1.56,3.46,3.46l0,0C204.59,177.94,203.03,179.5,201.13,179.5z"/>
			<path fill="#FFFFFF" d="M184.14,226.27h-78.65c-6.41,0-11.62-5.21-11.62-11.62s5.21-11.62,11.62-11.62h78.65
				c6.41,0,11.62,5.21,11.62,11.62C195.76,221.06,190.55,226.27,184.14,226.27z M105.49,203.83c-5.97,0-10.82,4.86-10.82,10.82
				c0,5.97,4.86,10.82,10.82,10.82h78.65c5.97,0,10.82-4.86,10.82-10.82c0-5.97-4.86-10.82-10.82-10.82H105.49z"/>
			<path fill="#FFFFFF" d="M123.86,223.48h-18.37c-4.86,0-8.83-3.97-8.83-8.83l0,0c0-4.86,3.97-8.83,8.83-8.83h18.37
				c4.86,0,8.83,3.97,8.83,8.83l0,0C132.69,219.51,128.72,223.48,123.86,223.48z"/>
			<g>
				<polygon fill="#007CFF" points="204.35,112.4 189.42,176.04 100.32,176.04 125.24,69.83 186.93,84.3 				"/>
				<polygon fill="#93A4D4" points="204.35,112.4 189.42,176.04 100.32,176.04 125.24,69.83 186.93,84.3 				"/>
				<g>
					<path fill="#3B4E9A" d="M192.73,124.23l-67.68-15.88c-0.97-0.23-1.58-1.21-1.35-2.18l0,0c0.23-0.97,1.21-1.58,2.18-1.35
						l67.68,15.88c0.97,0.23,1.58,1.21,1.35,2.18l0,0C194.68,123.85,193.7,124.45,192.73,124.23z"/>
					<path fill="#3B4E9A" d="M190.14,135.24l-67.68-15.88c-0.97-0.23-1.58-1.21-1.35-2.18l0,0c0.23-0.97,1.21-1.58,2.18-1.35
						l67.68,15.88c0.97,0.23,1.58,1.21,1.35,2.18l0,0C192.09,134.86,191.11,135.47,190.14,135.24z"/>
					<path fill="#3B4E9A" d="M187.56,146.26l-67.68-15.88c-0.97-0.23-1.58-1.21-1.35-2.18l0,0c0.23-0.97,1.21-1.58,2.18-1.35
						l67.68,15.88c0.97,0.23,1.58,1.21,1.35,2.18l0,0C189.51,145.88,188.53,146.48,187.56,146.26z"/>
					<path fill="#3B4E9A" d="M184.97,157.27l-67.68-15.88c-0.97-0.23-1.58-1.21-1.35-2.18l0,0c0.23-0.97,1.21-1.58,2.18-1.35
						l67.68,15.88c0.97,0.23,1.58,1.21,1.35,2.18l0,0C186.92,156.89,185.94,157.5,184.97,157.27z"/>
					<path fill="#3B4E9A" d="M155.48,161.97l-40.77-9.57c-0.97-0.23-1.58-1.21-1.35-2.18l0,0c0.23-0.97,1.21-1.58,2.18-1.35l40.77,9.57
						c0.97,0.23,1.58,1.21,1.35,2.18h0C157.43,161.59,156.45,162.2,155.48,161.97z"/>
				</g>
				<polygon fill="#3B4E9A" points="204.35,112.4 181.59,107.06 186.93,84.3 				"/>
			</g>
		</g>
		<g>
			<g>
				<path fill="#1A2E35" d="M219.63,172.83l-18.92,124.45h3.74l2.5-16.47h48.2l-2.5,16.47h3.74l18.92-124.45H219.63z M255.65,277.51
					h-48.2l2.68-17.66h48.2L255.65,277.51z M258.84,256.56h-48.2l2.68-17.66h48.2L258.84,256.56z M262.02,235.6h-48.2l2.68-17.66
					h48.2L262.02,235.6z M265.21,214.65h-48.2l2.68-17.66h48.2L265.21,214.65z M220.2,193.7l2.68-17.66h48.2l-2.68,17.66H220.2z"/>
				<g>
					<path fill="#1A2E35" d="M283.08,172.83h-55.67l18.92,124.45h3.74l-2.5-16.47h48.2l2.5,16.47H302L283.08,172.83z M231.64,176.04
						h48.2l2.68,17.66h-48.2L231.64,176.04z M234.82,196.99h48.2l2.68,17.66h-48.2L234.82,196.99z M238.01,217.95h48.2l2.68,17.66
						h-48.2L238.01,217.95z M241.2,238.9h48.2l2.68,17.66h-48.2L241.2,238.9z M247.07,277.51l-2.68-17.66h48.2l2.68,17.66H247.07z"
						/>
					<path fill="#93A4D4" d="M283.08,172.83h-55.67l18.92,124.45h3.74l-2.5-16.47h48.2l2.5,16.47H302L283.08,172.83z M231.64,176.04
						h48.2l2.68,17.66h-48.2L231.64,176.04z M234.82,196.99h48.2l2.68,17.66h-48.2L234.82,196.99z M238.01,217.95h48.2l2.68,17.66
						h-48.2L238.01,217.95z M241.2,238.9h48.2l2.68,17.66h-48.2L241.2,238.9z M247.07,277.51l-2.68-17.66h48.2l2.68,17.66H247.07z"
						/>
				</g>
			</g>
			<g>
				<path fill="#E49863" d="M259.23,51.69c1.6,1.23,3,2.46,4.46,3.74c1.45,1.26,2.84,2.59,4.21,3.94c2.74,2.71,5.36,5.58,7.79,8.71
					l0.89,1.2l0.44,0.6c0.25,0.35,0.5,0.74,0.68,1.11c0.77,1.5,1,2.89,1.1,4.13c0.17,2.48-0.21,4.58-0.67,6.59
					c-0.99,4-2.5,7.53-4.42,11.01l-4.08-1.66c0.77-3.47,1.47-7.11,1.73-10.47c0.12-1.67,0.11-3.32-0.14-4.56
					c-0.13-0.6-0.34-1.06-0.48-1.2c-0.03-0.04-0.05-0.04-0.08-0.06l-0.43-0.49l-0.86-0.98c-2.36-2.59-4.92-5.11-7.59-7.54
					c-2.64-2.43-5.43-4.87-8.11-7.13L259.23,51.69z"/>
				<path fill="#E49863" d="M271.25,89.42l-4.58,3.16l5.62,3.38c0,0,2.88-2.76,1.65-5.32L271.25,89.42z"/>
				<polygon fill="#E49863" points="264.39,97.86 268.62,100.24 272.29,95.97 266.67,92.58 				"/>
				<path fill="#E49863" d="M244.35,36.46c0.75,4.87,1.79,12.33,6.06,14.22c0,0,0.42,5.06-8.03,8.1c-9.29,3.34-6.1-3.01-6.1-3.01
					c4.64-3.04,3.15-6.75,1-9.97L244.35,36.46z"/>
				<path fill="#1A2E35" d="M251.21,49.67c0.03-1.53-1.56-4.17-3.13-3.99c-1.73,0.19-8.34,2.63-10.75,4.86
					c-2.41,2.23-0.7,6.13-0.7,6.13L251.21,49.67z"/>
				<polygon fill="#E49863" points="262.12,250.57 256.25,250.57 255.67,236.99 261.53,236.99 				"/>
				<polygon fill="#E49863" points="309.1,230.68 303.68,232.65 296.78,220.49 302.21,218.51 				"/>
				<path fill="#1A2E35" d="M302.82,232.12l4.58-4.73c0.17-0.17,0.43-0.21,0.63-0.08l4.55,2.79c0.47,0.29,0.54,0.95,0.15,1.34
					c-1.63,1.63-2.5,2.33-4.52,4.42c-1.24,1.28-4.93,5.62-6.64,7.39c-1.67,1.73-3.68,0.31-3.14-0.57c2.43-3.93,3.9-7.68,3.97-9.62
					C302.43,232.7,302.58,232.37,302.82,232.12z"/>
				<path fill="#1A2E35" d="M256.29,249.89h6.4c0.24,0,0.45,0.17,0.5,0.4l1.16,5.21c0.12,0.54-0.29,1.05-0.84,1.04
					c-2.31-0.04-5.65-0.17-8.55-0.17c-3.39,0-4.88,0.19-8.86,0.19c-2.41,0-3.08-2.43-2.07-2.65c4.59-1,6.88-1.11,10.85-3.56
					C255.31,250.08,255.78,249.89,256.29,249.89z"/>
				<path fill="#E49863" d="M240.36,63.34c-0.9,2.27-1.86,4.39-2.85,6.56c-0.98,2.16-2.04,4.28-3.13,6.4
					c-2.22,4.23-4.59,8.38-7.54,12.42c-0.74,1.01-1.54,2-2.42,2.99c-0.44,0.5-0.89,0.97-1.41,1.49c-0.69,0.65-1.35,1.12-1.99,1.53
					c-1.28,0.81-2.49,1.33-3.69,1.83c-1.2,0.49-2.38,0.88-3.57,1.23c-4.73,1.39-9.38,2.19-14.17,2.64l-0.89-4.31
					c4.27-1.55,8.62-3.14,12.61-4.94c0.99-0.46,1.96-0.93,2.87-1.42c0.9-0.49,1.76-1.02,2.4-1.53c0.32-0.25,0.58-0.49,0.71-0.66
					c0.28-0.32,0.61-0.71,0.91-1.1c0.62-0.79,1.22-1.64,1.81-2.54c1.19-1.78,2.29-3.7,3.36-5.65c1.07-1.95,2.09-3.96,3.09-5.99
					c1.98-4.04,3.91-8.24,5.68-12.33L240.36,63.34z"/>
				<path fill="#3B4E9A" d="M253.74,48.19c8.42-0.66,15.97,11.82,15.97,11.82l-6.05,9.82c0,0-6.48-2.38-11.96-7.13
					C245.97,57.73,247.99,48.64,253.74,48.19z"/>
				<path opacity="0.3"  d="M253.22,58.7l8.85,11.92l-0.4,0.49c0,0-3.05-2.42-6.57-5.86L253.22,58.7z"/>
				<path fill="#3B4E9A" d="M230.41,57.49c-0.47,4.11,6.41,22.29,8,43.86l31.21-3.07c-0.22-4.14-2.51-21.53-6.64-41.22
					c-1.14-5.43-5.35-9.61-10.79-8.51c-0.05,0.01-0.1,0.02-0.15,0.03c-3.93,0.81-9.58,2.12-12.92,3.31
					c-2.83,1.01-5.47,2.3-6.99,3.09C231.18,55.48,230.53,56.42,230.41,57.49z"/>
				<path fill="#284663" d="M233.57,72.59c0.53,2.2,1.08,4.57,1.62,7.1c4.75-1.12,3.83-11.65,3.93-11.79L233.57,72.59z"/>
				<path fill="#3B4E9A" d="M240.58,59.52c2.4,8.21-6.47,19.17-6.47,19.17l-8.92-5.75c0,0-0.06-7.52,2.79-13.4
					C231.59,52.09,238.87,53.67,240.58,59.52z"/>
				<path fill="#E49863" d="M198.84,95.37l-3.58-0.49l0.05,7.49c0,0,4.83,0.49,7.51-2.83l-0.53-1.41
					C201.74,96.64,200.41,95.58,198.84,95.37z"/>
				<polygon fill="#E49863" points="189.1,96.61 191.4,102.71 195.31,102.37 195.26,94.88 				"/>
				<g>
					<polygon fill="#D89060" points="255.67,236.99 256,244.63 261.86,244.63 261.54,236.99 					"/>
					<polygon fill="#D89060" points="302.21,218.52 296.78,220.49 300.6,227.23 305.77,224.79 					"/>
				</g>
				<path fill="#E49863" d="M244.92,29.51c1.24,6.44,2.29,10.15-0.08,14.22c-3.56,6.13-12.13,5.23-15.27-0.71
					c-2.82-5.35-4.37-14.98,1.19-19.09C236.24,19.87,243.68,23.07,244.92,29.51z"/>
				<path fill="#3C3C3B" d="M234.06,33.8c-3.92,1.96-4.01-4.31-3.68-5.64c-1.48,1.41-3.47,2.84-7.1,1.28c-4.45-1.92-3.19-6.95,0-6.88
					c0,0-2.37-4.55,2.85-5.03c2.9-0.27,6.33,0.98,6.33,0.98s1.94-5.08,6.67-2.62c2.5,1.3,4.49,5.15,4.49,5.15s10.18,1.51,4.66,6.83
					c1.25,2.73,0.59,11.61-2.65,15.41C244.23,44.93,232.14,44.45,234.06,33.8z"/>
				<path fill="#3C3C3B" d="M241.87,23.63c0,0,1.84-2.54,1.99-8.42C248.16,19.89,241.87,23.63,241.87,23.63z"/>
				<path fill="#D89060" d="M235.97,33.44c0.14,1.71-0.41,3.42-1.21,4.6c-1.2,1.78-2.83,1.01-3.36-0.86c-0.48-1.69-0.43-4.65,1.19-5.77
					C234.19,30.32,235.81,31.49,235.97,33.44z"/>
				<path fill="#63B347" d="M249.48,100.26c0,0,11.01,43.95,16.29,60.3c5.78,17.91,30.86,64.86,30.86,64.86l9.84-4.28
					c0,0-18.98-42.76-23.04-60.65c-4.4-19.42-13.82-62.22-13.82-62.22L249.48,100.26z"/>
				<path fill="#3E954E" d="M293.73,222.19c-0.04,0.02,3.22,4.62,3.22,4.62l11.05-4.89l-2.23-4.57L293.73,222.19z"/>
				<path opacity="0.5" fill="#3E954E" d="M255.23,115.74c7.81,0.75,9.81,29.39,10.33,44.16c-3.23-10.17-8.43-29.83-12.04-43.79
					C254.01,115.81,254.58,115.68,255.23,115.74z"/>
				<path fill="#63B347" d="M238.41,101.35c0,0,1.27,45.12,3.65,62.85c2.48,18.45,11.66,77.45,11.66,77.45h9.93
					c0,0-2.29-59.57-3.64-77.79c-1.47-19.87-1.09-64.53-1.09-64.53L238.41,101.35z"/>
				<path fill="#3E954E" d="M251.75,236.99c-0.05,0,0.79,6.01,0.79,6.01l12.08-0.42l0.11-5.6L251.75,236.99z"/>
			</g>
		</g>
	</g>
</g>
</svg>
